interface IconProps {
  color?: string
}

export const Draw = ({ color }: IconProps) => {
  return (
    <svg
      width="32"
      height="32"
      aria-hidden="true"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.29001 11.217C8.44296 9.86135 11.6651 14.9379 8.67022 18.118L7.9072 18.9266L6.89548 20.1037C4.67638 22.6822 8.17834 26.2079 10.7718 24.0061C11.1366 23.6964 11.6833 23.7416 11.9931 24.1063C12.3029 24.4711 12.2589 25.0179 11.8942 25.3277C7.67136 28.9131 1.9677 23.1707 5.58168 18.9722L6.60381 17.7847L6.62985 17.7561L7.4085 16.9292C9.17196 15.0561 7.27493 12.0663 4.82907 12.8641C4.37406 13.0127 3.88386 12.7645 3.73532 12.3094C3.58695 11.8547 3.83545 11.3658 4.29001 11.217Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9671 6.81335C23.725 6.05569 24.9539 6.05572 25.7119 6.81335L28.2926 9.39408C29.0501 10.152 29.0502 11.381 28.2926 12.1389L18.6494 21.7808C18.3759 22.0543 18.0264 22.2408 17.6468 22.3147L14.445 22.9371C13.0943 23.1995 11.9065 22.0117 12.1689 20.661L12.7913 17.4579C12.8652 17.0787 13.0508 16.7298 13.3239 16.4566L19.3812 10.398C19.3748 10.3706 19.3663 10.3434 19.3603 10.316L19.4931 10.286L22.9671 6.81335ZM14.5504 17.6818C14.5214 17.7109 14.5011 17.7484 14.4931 17.7886L13.8707 20.9917C13.8427 21.1362 13.9698 21.2633 14.1142 21.2352L17.316 20.6128C17.3566 20.6049 17.3949 20.5848 17.4241 20.5555L22.958 15.0204C21.7295 14.3777 20.7186 13.3871 20.0556 12.174L14.5504 17.6818ZM24.4866 8.03862C24.4056 7.95789 24.2734 7.95786 24.1924 8.03862L21.3538 10.8772C21.9036 12.1705 22.9486 13.197 24.2614 13.717L27.0674 10.9123C27.1476 10.8312 27.1469 10.7002 27.066 10.6193L24.4866 8.03862Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
